import { render, staticRenderFns } from "./EnviarEstudioExpress.vue?vue&type=template&id=21a4fce8&"
import script from "./EnviarEstudioExpress.vue?vue&type=script&lang=js&"
export * from "./EnviarEstudioExpress.vue?vue&type=script&lang=js&"
import style0 from "./EnviarEstudioExpress.vue?vue&type=style&index=0&id=21a4fce8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports